import script from "./LanguageSwitchComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSwitchComponent.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSwitchComponent.vue?vue&type=style&index=0&id=1a0be956&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a0be956"]])

export default __exports__